import React from 'react';
import { ArticleCollectionView } from '@reverbdotcom/commons/src/components/article_collection_view';

interface Props {
  articles: any[];
  heading: string;
  action?: JSX.Element;
}

export default function RelatedArticles(props: Props) {
  if (props.articles.length < 2) { return null; }

  return (
    <ArticleCollectionView
      title={props.heading}
      articles={props.articles}
      action={props.action}
    />
  );
}
